module.exports = __webpack_public_path__ + "static/media/industry_bg.9f56fdcb.png";